import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
// import Textinput from "../elements/TextInput/TextInput";
import Button from "../elements/Button/Button";
import Jobscreen from "./JobScreen";
import Jobscreening from "./JobScreening";
import JobTeam from "./JobTeam";
import { useNavigate, useLocation } from "react-router-dom";
import { useCommonContext } from "../../context/CommonContext";
import { AuthContext } from "../../context/AuthContext";
import CryptoJS from "crypto-js";
import JobSchedule from "./JobSchedule";
import "./JobScreen.css";
import ButtonHallow from "../elements/Button/ButtonHallow";
const JobPost = () => {
  const [Heading, setHeading] = useState("Post a New Job");
  const { token } = useContext(AuthContext);
  const location = useLocation();
  const reschedule = location.state?.reschedule || false;
  let plan_id;
  const { jobCreationData, setValidationErrors, setJobCreationData } =
    useCommonContext();
  const encryptedMetadata = localStorage.getItem("metadata");
  if (encryptedMetadata) {
    let decryptedMetadata = JSON.parse(
      CryptoJS.AES.decrypt(
        encryptedMetadata,
        process.env.REACT_APP_SECRETKEY
      ).toString(CryptoJS.enc.Utf8)
    );
    console.log(decryptedMetadata, "decryptedMetadata");
    if (decryptedMetadata && decryptedMetadata.plan_id)
      plan_id = decryptedMetadata.plan_id;
  }
  const [nextScreen, setNextScreen] = useState(1);

  useEffect(() => {
    if (reschedule) {
      setNextScreen(4);
    }
  }, [reschedule]);
  const navigate = useNavigate();
  // useEffect(() => {

  // }, [jobCreationData]);

  // Retrieve jobCreationData from localStorage during initialization
  useEffect(() => {
    const savedFormData = localStorage.getItem("jobCreationData");
    if (savedFormData) {
      setJobCreationData(JSON.parse(savedFormData));
    }
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const sendData = async (data, reschedule = false) => {
    let apiName = "createJob";
    if (reschedule) {
      apiName = "updateJobSchedule";
    }
    if (!data.jobid || data.jobid === "") {
      console.log("jobid is empty");
      data.jobid = Math.floor(1000 + Math.random() * 9000).toString();
    } else {
      data.jobid = data.jobid.toString();
    }
    data.plan_id = plan_id;
    console.log(data);
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      process.env.REACT_APP_SECRETKEY
    ).toString();
    const encryptjson = { data: encryptedData };

    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/job/${apiName}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify(encryptjson),
        }
      );

      if (response.ok) {
        localStorage.removeItem("jobCreationData");
        Swal.fire({
          icon: "success",
          title: reschedule
            ? "Job Rescheduled Successfuly!"
            : "Job successfully added to verification!",
          text: reschedule ? "" : "Once verified, it will go live.",
          // showConfirmButton: false,
          confirmButtonText: "OK",
        }).then(() => {
          window.location.href = "/Dashboard";
        });
      } else {
        const errorResponse = await response.json();
        if (errorResponse.status === "error") {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorResponse.error, //'There was an issue adding the job. Please try again.',
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "There was an issue adding the job. Please try again.",
          });
        }
      }
    } catch (error) {
      console.log("Error adding JD to db:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred. Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async (force = false) => {
    const errors = {};
    const firstStageJC = [
      "jobTitle",
      "company",
      "workplaceType",
      "jobLocation",
      "jobType",
      "description",
      "selectedSkills",
    ];
    const secondStageJC = ["questions"];
    if (force && nextScreen === 2) {
      await setJobCreationData((prevData) => ({
        ...prevData,
        questions: [],
      }));
    }

    Object.keys(jobCreationData).forEach((key) => {
      if (nextScreen === 1) {
        if (firstStageJC.includes(key)) {
          if (
            !jobCreationData[key] ||
            (Array.isArray(jobCreationData[key]) &&
              jobCreationData[key].length === 0)
          ) {
            errors[key] = true;
          }
        }
      } else if (nextScreen === 2 && !force) {
        if (
          !jobCreationData["questions"] ||
          (Array.isArray(jobCreationData["questions"]) &&
            jobCreationData["questions"].length < 3)
        ) {
          errors["questions"] = true;
        } else {
          jobCreationData.questions.forEach((question, index) => {
            if (
              !question.question_desc ||
              question.question_desc.trim() === ""
            ) {
              errors["desc-" + index] = true;
            }
          });
          jobCreationData.questions.forEach((question, index) => {
            if (!question.minimum || question.minimum.trim() === "") {
              errors["minimum-" + index] = true;
            }
          });

          jobCreationData.questions.forEach((question, index) => {
            if (
              question.question_desc &&
              question.question_desc?.includes("[value]")
            ) {
              errors["value-" + index] = true;
            }
          });
        }
      } else if (nextScreen === 3) {
        if (
          !jobCreationData["collaborators"] ||
          (Array.isArray(jobCreationData["collaborators"]) &&
            jobCreationData["collaborators"].length === 0)
        ) {
          errors["collaborators"] = true;
        }
      } else if (nextScreen === 4 && !force) {
        if (
          !jobCreationData["interviewers"] ||
          (Array.isArray(jobCreationData["interviewers"]) &&
            jobCreationData["interviewers"].length === 0)
        ) {
          errors["interviewers"] = true;
        }
        if (
          !jobCreationData["timezone"] ||
          (Array.isArray(jobCreationData["timezone"]) &&
            jobCreationData["timezone"].length === 0)
        ) {
          errors["timezone"] = true;
        }
        if (
          !jobCreationData["interview_duration"] ||
          (Array.isArray(jobCreationData["interview_duration"]) &&
            jobCreationData["interview_duration"].length === 0)
        ) {
          errors["interview_duration"] = true;
        }
        if (
          !jobCreationData["schedule_config_days"] ||
          (Array.isArray(jobCreationData["schedule_config_days"]) &&
            jobCreationData["schedule_config_days"].length === 0)
        ) {
          errors["schedule_config_days"] = true;
        }
        if (
          !jobCreationData["interview_location"] ||
          (Array.isArray(jobCreationData["interview_location"]) &&
            jobCreationData["interview_location"].length === 0)
        ) {
          errors["interview_location"] = true;
        }

        if (
          !jobCreationData["slots"] ||
          (typeof jobCreationData["slots"] === "object" &&
            Object.keys(jobCreationData["slots"]).length === 0)
        ) {
          errors["slots"] = true;
        } else {
          // Validate that each slot has both 'from' and 'to' times
          Object.entries(jobCreationData["slots"]).forEach(
            ([day, timeRange]) => {
              const [fromTime, toTime] = timeRange.split(" - ");
              if (!fromTime || !toTime) {
                errors["slots"] = true;
              }
            }
          );
        }
      }
    });
    localStorage.setItem("jobCreationData", JSON.stringify(jobCreationData));
    if (encryptedMetadata) {
      const decryptedMetadata = JSON.parse(
        CryptoJS.AES.decrypt(
          encryptedMetadata,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      setJobCreationData((prev) => ({
        ...prev,
        company_id: decryptedMetadata.cid,
      }));
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      console.log("Validation failed:", errors);
      return;
    }

    setValidationErrors({});

    if (nextScreen === 4) {
      console.log(jobCreationData);
      if (force) {
        const updatedJobCreationData = {
          ...jobCreationData,
          slots: [],
          interview_duration: "",
          interview_location: "",
          timezone: "",
          schedule_config_days: "0",
        };
        sendData(updatedJobCreationData);
      } else if (reschedule) {
        sendData(jobCreationData, true);
      } else {
        sendData(jobCreationData);
      }
    }
    setNextScreen((prevScreen) =>
      prevScreen < 4 ? prevScreen + 1 : prevScreen
    );
    if (nextScreen === 3) {
      setHeading("Set Schedule");
    }
    console.log("next: ", nextScreen);
  };
  const handleBack = () => {
    if (nextScreen === 1) {
      navigate("/JobDashboard");
    } else {
      setNextScreen((prevScreen) =>
        prevScreen > 1 ? prevScreen - 1 : prevScreen
      );
      console.log("next: ", nextScreen);
    }
  };
  const handleJobPrevie = () => {
    localStorage.removeItem("jobCreationData");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-3 lg:px-8 py-6">
        <div className="mb-6">
          <p className="font-[700] text-2xl sm:text-3xl lg:text-4xl mb-2">
            {Heading}
          </p>

          {/* Progress Indicator */}
          <div className="flex items-center justify-center mt-6 mb-8">
            <div className="flex items-center w-full max-w-2xl">
              <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10">
                <p className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full text-white bg-[#059669] text-sm sm:text-base font-medium">
                  1
                </p>
              </div>
              <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>
              <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10">
                <p
                  className={`flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-[#059669] text-sm sm:text-base font-medium ${
                    nextScreen === 3 || nextScreen === 4
                      ? "bg-[#059669] text-white"
                      : "bg-teal-50 text-green-900"
                  }`}
                >
                  2
                </p>
              </div>
              <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>
              <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10">
                <p
                  className={`flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-[#059669] text-sm sm:text-base font-medium ${
                    nextScreen === 4
                      ? "bg-[#059669] text-white"
                      : "bg-teal-50 text-green-900"
                  }`}
                >
                  3
                </p>
              </div>
              <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>
              <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10">
                <p className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full text-green-900 border-2 border-[#059669] bg-teal-50 text-sm sm:text-base font-medium">
                  4
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Loading Overlay */}
        {isLoading && (
          <div className="flex items-center justify-center h-full w-full bg-opacity-70 bg-gray-50 fixed top-0 left-0 z-50">
            <div
              className="text-center"
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="loader"></div>
              <p
                className="text-lg font-medium mt-4 animate-pulse"
                style={{ color: "#ffffff" }}
              >
                Submitting your job request... Please wait!
              </p>
            </div>
          </div>
        )}

        {/* Main Content */}
        <div className="w-full bg-white bg-opacity-50 rounded-xl py-4 px-1 sm:p-0 lg:p-8 shadow-sm">
          {nextScreen === 1 ? <Jobscreen /> : null}
          {nextScreen === 2 ? <Jobscreening /> : null}
          {nextScreen === 3 ? <JobTeam /> : null}
          {nextScreen === 4 ? <JobSchedule reschedule={reschedule} /> : null}

          {/* Action Buttons */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 sm:justify-end">
              {!reschedule && (
                <Button
                  className="px-6 py-2 text-white font-medium text-sm w-full sm:w-auto order-3 sm:order-1"
                  onClick={() => handleBack()}
                >
                  Back
                </Button>
              )}
              {(nextScreen === 2 || nextScreen === 4) && !reschedule && (
                <Button
                  className="px-6 py-2 text-white font-medium text-sm w-full sm:w-auto order-2 sm:order-2"
                  onClick={() => handleSave(true)}
                >
                  {nextScreen === 4 ? "Skip & Submit" : "Skip"}
                </Button>
              )}
              <Button
                className="px-6 py-2 text-white font-medium text-sm w-full sm:w-auto order-1 sm:order-3"
                onClick={() => handleSave()}
              >
                {nextScreen === 4
                  ? reschedule
                    ? "Reschedule Job"
                    : "Submit For Approval"
                  : "Save & Proceed"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default JobPost;
